import { ReferenceSection } from "../../common";

export function getColCount(section: ReferenceSection): number {
    if (section.header !== null && section.header.length > 0)
        return section.header.length;
    if (section.rows.length === 0)
        return 1;
    return Math.max(...section.rows.map(r => r.cells.length));
}
